// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"e76c6297","192":"69af0252","253":"54a7ef9d","292":"04104844","580":"81087eb0","671":"951ea0db","699":"b1d919ab","784":"e76cb9f8","834":"e2eca239","941":"fe71eed6"}[chunkId] + ".chunk.js";
};